import React from 'react';

interface ErrorBoundaryState {
    error: string | null;
}

export class WidgetErrorBoundary extends React.Component<{ children: React.ReactNode }, ErrorBoundaryState> {
    constructor(props: { children: React.ReactNode }) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { error: `${error.message}\n${error.stack?.split('\n').slice(0, 4).join('\n') ?? ''}` };
    }

    render() {
        if (this.state.error) {
            return <div style={{ padding: '16px', fontFamily: 'monospace', fontSize: '11px', color: '#f88', background: '#1a1a1a', borderRadius: '8px', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{this.state.error}</div>;
        }
        return this.props.children;
    }
}
